import api from "./api";

const qs = (p) => new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null));

const funcionariosService = {
  listar:        (p = {}) => api("GET", `/funcionarios?${qs(p)}`),
  stats:         (p = {}) => api("GET", `/funcionarios/stats?${qs(p)}`),
  listarCargos:  (p = {}) => api("GET", `/funcionarios/cargos?${qs(p)}`),
  buscarPorId:   (id)     => api("GET", `/funcionarios/${id}`),
  criar:         (data)   => api("POST", "/funcionarios", data),
  atualizar:     (id, data) => api("PUT", `/funcionarios/${id}`, data),
  alterarStatus: (id, inativo) => api("PATCH", `/funcionarios/${id}/status`, { inativo }),
  deletar:       (id)     => api("DELETE", `/funcionarios/${id}`),
};

export default funcionariosService;
